import { render, staticRenderFns } from "./bizCardAddPage.vue?vue&type=template&id=04bba60c&scoped=true&"
import script from "./bizCardAddPage.vue?vue&type=script&lang=js&"
export * from "./bizCardAddPage.vue?vue&type=script&lang=js&"
import style0 from "./bizCardAddPage.vue?vue&type=style&index=0&id=04bba60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bba60c",
  null
  
)

export default component.exports